import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("bizkeep_token");
    const email = localStorage.getItem("bizkeep_email");
    const userType = localStorage.getItem("bizkeep_user_type") || "business";
    if (token && email) {
      setIsAuthenticated(true);
      setUser({ email, token, userType });
    }
    setLoading(false);
  }, []);

  const login = (token, email, userType = "business") => {
    localStorage.setItem("bizkeep_token", token);
    localStorage.setItem("bizkeep_email", email);
    localStorage.setItem("bizkeep_user_type", userType);
    setIsAuthenticated(true);
    setUser({ email, token, userType });
  };

  const logout = () => {
    localStorage.removeItem("bizkeep_token");
    localStorage.removeItem("bizkeep_email");
    localStorage.removeItem("bizkeep_user_type");
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
